import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'prlw-last-deals-fetch-more-button-ui',
  templateUrl: './last-deals-fetch-more-button.component.html',
  styleUrl: './last-deals-fetch-more-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LastDealsFetchMoreButtonComponent {
  @Input() buttonLoading: boolean | null = null;
  @Input() fetchMoreLabel: string | null = null;

  @Output() eventFetchMore = new EventEmitter<void>();
}
